import { render, staticRenderFns } from "./BlockLocationsModal.vue?vue&type=template&id=f9e2f6a4&scoped=true&"
import script from "./BlockLocationsModal.vue?vue&type=script&lang=ts&"
export * from "./BlockLocationsModal.vue?vue&type=script&lang=ts&"
import style0 from "./BlockLocationsModal.vue?vue&type=style&index=0&id=f9e2f6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e2f6a4",
  null
  
)

export default component.exports